import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import cx from 'classnames'

import { makeStyles } from '@material-ui/core/styles'
import { Button, Divider, ListItem, Typography, Grid } from '@material-ui/core'
import { MoreHoriz, Room, Star } from '@material-ui/icons'

import { useLiterals } from '~/components/Literals'
import ProductImageThumb from '~/components/ProductImageThumb'

import track from '~/track'

const useStyles = makeStyles((theme) => ({
  item: {
    padding: 8,
    gap: 16,
    backgroundColor: '#FFF'
  },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #EEE',
    borderRight: '1px solid #EEE'
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  text: {
    paddingLeft: 8,
    paddingRight: 8,
    ...theme.gofind.lineLimit(2),
    '& span': {
      ...theme.gofind.lineLimit(2),
      maxHeight: 52,
      overflow: 'hidden'
    }
  },
  description: {
    paddingLeft: 8,
    paddingRight: 8,
    margin: 0,
    color: theme.palette.text.secondary,
    maxHeight: 42,
    ...theme.gofind.lineLimit(2)
  },
  featured: {
    background: '#fffbc8',
    '&.new $badge': {
      background: '#e74c3c'
    },
    '&.default $badge': {
      background: '#2980b9'
    }
  },
  badge: {
    padding: '0 4px',
    position: 'absolute',
    left: 8,
    top: 8,
    color: '#fff',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    textTransform: 'uppercase',
    '& svg': {
      fontSize: '15px'
    }
  }
}))

function Product({ product, onSelectProduct, position, mode }) {
  const classes = useStyles()
  const history = useHistory()

  const { getLiteral } = useLiterals()
  const { featured, name, description, gtin } = product

  const handleViewProduct = async (e, product) => {
    e.preventDefault()
    e.stopPropagation()

    history.push(`/produto/${product.gtin}/detalhes`, {
      fromApp: true,
      prevPath: history.location.pathname
    })
  }

  const handleCheckGeolocation = async (e, product) => {
    e.stopPropagation()

    if (!Boolean(position.user?.lat) || !Boolean(position.user?.lng)) {
      position.handlerShowPositionDialog(true)
      return
    }

    handleViewProduct(e, product)
  }

  return (
    <>
      <ListItem
        data-cy="product"
        onClick={() => onSelectProduct(product)}
        aria-label={`${getLiteral('2036')} ${name}`}
        className={cx(classes.item, {
          [classes.grid]: mode,
          [classes.featured]: Boolean(featured),
          [featured ? featured.type : '']: Boolean(featured)
        })}
        data_analytics_category="onde-comprar"
        data_analytics_action="search_product"
        data_analytics_product_id={gtin}
        data_analytics_product_name={name}
        data_analytics_product_size={name}
        data_analytics_product_type={name}
        data_analytics_local={position?.user?.city}
      >
        <ProductImageThumb product={product} />

        <Grid {...(mode && { className: classes.column })} style={{ width: '100%' }}>
          <Typography variant="body1" data-cy="productName" className={classes.text}>
            {name}
          </Typography>

          {!mode ? (
            <Typography className={classes.description}>{description}</Typography>
          ) : (
            <Grid style={{ padding: 8 }} />
          )}

          <Button>
            <Room color="primary" />
            {getLiteral('1993')}
          </Button>
          <Button onClick={(e) => handleCheckGeolocation(e, product)}>
            <MoreHoriz color="primary" />
            {getLiteral('1005')}
          </Button>
        </Grid>

        {featured && featured.type === 'new' && (
          <Typography variant="caption" component="span" className={classes.badge}>
            {featured.type === 'new' && (
              <>
                <Star />
                {getLiteral('2037')}
              </>
            )}
            {featured.type === 'default' && 'hot'}
          </Typography>
        )}
      </ListItem>
      {!mode && <Divider />}
    </>
  )
}

export default memo(Product)
